// import Modules
import { Box } from '@mui/material';
import React from 'react';
import Typography from "../../atoms/Typography";
import HtmlRenderer from "../../atoms/HtmlRenderer";
import Container from "../../atoms/Container";

// import Styles
import colors from "../../theme/colors";

// import Types
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const KeyFeature = props => {
  const {
    title,
    descriptionTop,
    descriptionBottom,
    image,
    imagePosition = "right",
    typeBorder = "waves"
  } = props;
  const shapes = {
    waves: 'https://images.ctfassets.net/hnoi7ctzfs57/1wMwrYRi8GoOGVMuFOtU3c/108173995f10342536fc3ff7961b7560/Vector__2_.svg',
    pyramid: 'https://images.ctfassets.net/hnoi7ctzfs57/38Ua4jzKej8J6Ph2NHIrTs/43e3bc2388d130039117e3d53045d165/Vector__1_.svg',
    triangle: 'https://images.ctfassets.net/hnoi7ctzfs57/1wMwrYRi8GoOGVMuFOtU3c/398d8b6b84de75961d753c81c82f36bd/Vector__3_.svg',
    circle: "https://images.ctfassets.net/hnoi7ctzfs57/3MqjBku7xf8IFJrQWr64ra/7c2f87f8456f1ab8cb558f4ace045549/Vector.svg",
    square: 'https://images.ctfassets.net/hnoi7ctzfs57/1wMwrYRi8GoOGVMuFOtU3c/11392f9dbc1bcc6fbe6652662a9a4b6c/Vector__4_.svg',
    oval: "https://images.ctfassets.net/hnoi7ctzfs57/1wMwrYRi8GoOGVMuFOtU3c/860ba2ee45dc999656fb50c1f8cbdcbc/Vector__5_.svg",
    trapezium: 'https://images.ctfassets.net/hnoi7ctzfs57/1wMwrYRi8GoOGVMuFOtU3c/398d8b6b84de75961d753c81c82f36bd/Vector__3_.svg',
    ellipse: 'https://images.ctfassets.net/hnoi7ctzfs57/1wMwrYRi8GoOGVMuFOtU3c/860ba2ee45dc999656fb50c1f8cbdcbc/Vector__5_.svg',
    trapezium_vertical: 'https://images.ctfassets.net/hnoi7ctzfs57/38Ua4jzKej8J6Ph2NHIrTs/398592c51f1d8e1ae7339c1a3b34c965/Vector__6_.svg',
    half_an_ellipse: 'https://images.ctfassets.net/hnoi7ctzfs57/38Ua4jzKej8J6Ph2NHIrTs/d974c0147e6678cfe1a6a92fff89722a/Vector__7_.svg',
    half_a_circle: 'https://images.ctfassets.net/hnoi7ctzfs57/38Ua4jzKej8J6Ph2NHIrTs/d974c0147e6678cfe1a6a92fff89722a/Vector__7_.svg'
  };
  const renderPaddingBottomHeightMobile = () => {
    if (typeBorder === "pyramid") {
      return "100%";
    }
    if (typeBorder === "triangle") {
      return "91.79%";
    }
    if (typeBorder === "oval") {
      return {
        xs: "142%",
        md: "106%"
      };
    }
    if (typeBorder === "ellipse") {
      return {
        xs: '142%',
        md: "106%"
      };
    }
    if (typeBorder === "trapezium_vertical") {
      return {
        xs: "134%",
        md: '102%'
      };
    }
    if (typeBorder === "half_an_ellipse") {
      return {
        xs: '109%',
        md: "104%"
      };
    }
    if (typeBorder === "half_a_circle") {
      return "50.43%";
    }
    return "100%";
  };
  const renderMaxWidth = () => {
    if (typeBorder === "oval") {
      return "335px";
    }
    if (typeBorder === "ellipse") {
      return "335px";
    }
    if (typeBorder === "trapezium_vertical") {
      return "335px";
    }
    if (typeBorder === "half_an_ellipse") {
      return "335px";
    }
    return "451px";
  };
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: "flex",
        width: {
          xs: "100%",
          xl: "1116px"
        },
        alignItems: "center",
        flexDirection: {
          xs: "column",
          lg: imagePosition === "right" ? "row-reverse" : "row"
        },
        marginBottom: {
          md: "82px",
          lg: "0px"
        },
        '&:last-child': {
          marginBottom: "0px"
        }
      },
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          width: '100%',
          maxWidth: {
            xs: '100%',
            md: '451px'
          }
        },
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            width: {
              xs: "100%",
              md: "100%"
            },
            paddingBottom: renderPaddingBottomHeightMobile(),
            maxWidth: renderMaxWidth(),
            margin: '0 auto',
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            maskImage: typeBorder !== "none" ? `url(${shapes?.[`${typeBorder}`]})` : 'none',
            maskSize: typeBorder === 'half_an_ellipse' ? 'contain' : "100%",
            maskRepeat: " no-repeat",
            maskPosition: "center"
          }
        })
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          width: '100%',
          display: "flex",
          maxWidth: {
            xs: "720px",
            lg: "451px"
          },
          flexDirection: "column",
          justifyContent: {
            xs: 'flex-start'
          },
          height: "100%",
          marginLeft: {
            xs: "0px",
            lg: imagePosition === "left" ? "118px" : "0px"
          },
          marginRight: {
            md: "0px",
            lg: imagePosition === "left" ? "0px" : "118px"
          },
          paddingTop: {
            xs: "46px",
            lg: "0px"
          }
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h5",
          sx: {
            textAlign: "left",
            WebkitLineClamp: 2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitBoxOrient: 'vertical',
            display: '-webkit-box',
            color: colors.primary.bandaiNamcoBlack
          },
          children: /*#__PURE__*/_jsx(HtmlRenderer, {
            component: 'div',
            value: title
          })
        }), descriptionTop && /*#__PURE__*/_jsx(Typography, {
          variant: "p6",
          sx: {
            marginTop: "22px",
            letterSpacing: "-0.2px",
            lineHeight: {
              md: "20px",
              lg: "22px"
            },
            color: colors.neutral.neutral2
          },
          children: /*#__PURE__*/_jsx(HtmlRenderer, {
            component: 'p',
            value: descriptionTop
          })
        }), descriptionBottom && /*#__PURE__*/_jsx(Typography, {
          variant: "p6",
          sx: {
            marginTop: "22px",
            letterSpacing: "-0.2px",
            lineHeight: {
              md: "20px",
              lg: "22px"
            },
            color: colors.neutral.neutral2
          },
          children: /*#__PURE__*/_jsx(HtmlRenderer, {
            component: 'p',
            value: descriptionBottom
          })
        })]
      })]
    })
  });
};
export default KeyFeature;